<template>
  <div class="custom-select-box-wrap">
    <label v-if="label">{{ label }}</label>
    <select class="custom-select-box" :class="{'is-invalid' : isInvalid}" :value="value" @input="handleChange" :disabled="disabled">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
    <span v-if="isInvalid" class="invalid-msg">{{ invalid }}</span>
  </div>
</template>
<script>
export default {
  name: 'CustomSelectBox',
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    invalid: {
      type: String,
      required: false,
      default: '',
    }
  },
  computed: {
    isInvalid() {
      return this.invalid ? true : false;
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('onChange', e.target.value);
    }
  }
}

</script>
<style scoped>
label {
  margin-right: 0.333rem;
}

.custom-select-box-wrap {
  position: relative;
}

.custom-select-box {
  appearance: none;
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  min-width: 9vw;
}

.custom-select-box:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-select-box.is-valid {
  border: 1px solid #00A438;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select-box.is-invalid {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select-box.is-valid:focus {
  box-shadow: none;
  border: 1px solid #00A438;
}

.custom-select-box.is-invalid:focus {
  box-shadow: none;
  border: 1px solid #FF0000;
}

.custom-select-box:disabled {
  border: 1px solid #E7E7EE !important;
  background-color: #E0E0E7 !important;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M16.5 7.5L10.6667 13.3333L4.83333 7.5" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.invalid-msg {
  color: #ff0000;
  position:absolute;
  bottom: -50%;
  left: 0;
}

</style>